import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";

import {
    setRoles as setRolesAction,
    setSystems as setSystemsAction,
    setMatrixHeaders as setMatrixHeadersAction,
    setRisks as setRisksAction,
    setRiskLevels as setRiskLevelsAction,
    setParametersOpen as setParametersOpenAction,
    // setVariantWithFetchModeling,
    initModelingManual,
} from "../../../reducers/reports-modeling/roleLevelSlice";

import useReduxValue from "../../common/hooks/useReduxValue";

import { MatrixIdsInput, RiskIdsInput, RiskLevelInput, SystemIdsInput } from "../../sod-reports/report-parameters";

import ReportModelingParameters, { RolesInput } from "../report-modeling-parameters";
import { reportsService } from "../../../services/reports-service";
import { useNavigate } from "react-router-dom";

const getSystems = (params, signal) => {
    return reportsService.getSystemsForSimulationSearchHelp(params, signal);
};

const RoleLevelModelingParameters = ({ onShowVariantsClick }) => {
    const intl = useIntl();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const currentVariant = useSelector((state) => state.reportsModeling.roleLevel.currentVariant);

    const [roles, setRoles] = useReduxValue((state) => state.reportsModeling.roleLevel.parameters.roles, setRolesAction);
    //const [systems, setSystems] = useReduxValue(state => state.reportsModeling.roleLevel.systems, setSystemsAction);
    const [systems, setSystems] = useReduxValue((state) => state.reportsModeling.roleLevel.parameters.systems, setSystemsAction);
    const [matrixHeaders, setMatrixHeaders] = useReduxValue(
        (state) => state.reportsModeling.roleLevel.parameters.matrixHeaders,
        setMatrixHeadersAction
    );
    const [risks, setRisks] = useReduxValue((state) => state.reportsModeling.roleLevel.parameters.risks, setRisksAction);
    const [riskLevels, setRiskLevels] = useReduxValue((state) => state.reportsModeling.roleLevel.parameters.riskLevels, setRiskLevelsAction);
    const [open, setOpen] = useReduxValue((state) => state.reportsModeling.roleLevel.parametersOpen, setParametersOpenAction);

    const isAnalyzeDisabled = !(roles?.length && systems.length === 1);

    const titles = [intl.formatMessage({ id: "role-level-report-page.title" })];

    if (currentVariant) {
        titles.push(intl.formatMessage({ id: "user-level-report-page.variant-selected.title" }, { name: currentVariant.name }));
    }

    const handleOpenClick = (event) => {
        event.stopPropagation();
        setOpen(!open);
    };

    const handleApply = async () => {
        await dispatch(initModelingManual()).unwrap();
        navigate("/modeling-role-level");
    };

    return (
        <ReportModelingParameters
            title={titles.join(" ")}
            open={open}
            applyDisabled={isAnalyzeDisabled}
            onOpenClick={handleOpenClick}
            onShowVariantsClick={onShowVariantsClick}
            onApplyClick={handleApply}
        >
            <RolesInput ids={roles} setIds={setRoles} />

            <SystemIdsInput tags={systems} setTags={setSystems} getSystems={getSystems} disabledMultiple={true} />

            <MatrixIdsInput tags={matrixHeaders} setTags={setMatrixHeaders} />

            <RiskIdsInput tags={risks} setTags={setRisks} />

            <RiskLevelInput tags={riskLevels} setTags={setRiskLevels} />
        </ReportModelingParameters>
    );
};

RoleLevelModelingParameters.propTypes = {
    onShowVariantsClick: PropTypes.func,
};

export default RoleLevelModelingParameters;
